const Modal = require('app/ui/Modal');
const GraphQLMutation = require('app/graphql/Mutation');

class ExcelModal {

    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': window.translate('app.product.export.excel.title'),
            'onClose': function(event){},
            'onShown': function(event){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmit = this.onSubmit.bind(this);
        this.onChangeCheckboxEnableFilter = this.onChangeCheckboxEnableFilter.bind(this);

        this.initialize();
    }

    initialize() {
        var self = this;

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('product-export-excel-modal');

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "xl",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.buildContent();

        this.modal.show();
    }

    refresh(){
        this.buildContent();
    }

    buildContent(){
        this.$resultContainer = $('<div/>');

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-primary')
        .append(window.translate('app.product.export.excel.submit.label'))


        let from = moment().startOf('year').format('YYYY-MM-DD');
        let to = moment().endOf('year').format('YYYY-MM-DD');

        this.$inputFrom = $('<input/>')
        .attr('name','from')
        .attr('type','date')
        .addClass('form-control')
        .attr('disabled','disabled')
        .val(from);

        this.$inputTo = $('<input/>')
        .attr('name','to')
        .attr('type','date')
        .addClass('form-control')
        .attr('disabled','disabled')
        .val(to);

        this.$checkboxEnableFilter = $('<input/>')
        .attr('id','enableExportFilter')
        .attr('type','checkbox')
        .on('change',this.onChangeCheckboxEnableFilter);

        let $enableFiltersContainer = $('<div/>')
        .append(this.$checkboxEnableFilter)
        .append(
            $('<label/>')
            .attr('for','enableExportFilter')
            .addClass('ms-1')
            .append(window.translate('app.product.export.excel.filter.label'))
        )

        this.$filterContainer = $('<div/>')
        .addClass('row')
        .hide()
        .append(
            $('<div/>')
            .addClass('col-6 p-2 form-group')
            .append(
                $('<label/>')
                .append(window.translate('from'))
            )
            .append(this.$inputFrom)
        )
        .append(
            $('<div/>')
            .addClass('col-6 p-2 form-group')
            .append(
                $('<label/>')
                .append(window.translate('to'))
            )
            .append(this.$inputTo)
        );

        this.$form = $('<form/>')
        .addClass('product-export-form')
        .append($enableFiltersContainer)
        .append(this.$filterContainer)
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-2')
            .append(this.$btnSubmit)
        )
        .on('submit',this.onSubmit);

        this.$content
        .append(this.$form)
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-4')
            .append(this.$resultContainer)
        )

    }

    onSubmit(event){
        event.preventDefault();
        event.stopPropagation();

        this.generateFile();
    }

    getParametersAsString(){
        let parameters = {
            'filter': {
                'notStatus': 3
            },
            'orderBy': 'reference',
            'dir': 'ASC'
        };
        if(this.$inputFrom.is(':enabled') && this.$inputTo.is(':enabled') && this.$inputFrom.val() && this.$inputTo.val()){
            parameters['filter']['from'] = this.$inputFrom.val();
            parameters['filter']['to'] = this.$inputTo.val();
        }
        return JSON.stringify(parameters);
    }

    generateFile(){
        var self = this;

        let $spinner = window.App.generateLoader();

        this.$resultContainer
        .html('')
        .append($spinner)
        .show();

        let fields = [
            'success',
            'message',
            'file { url id }',
            'errors { key, value }',
        ];
        let variables = {
            'type':{
                'value': 'excel',
                'type': "String!"
            },
            'queryParameters': {
                'value': this.getParametersAsString(),
                'type': "String"
            }
        };

        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "ExportSupplierProduct",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    self.showResult(data);
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                $spinner.remove();
            }
        });
        mutation.execute();

    }

    showResult(data){
        let url = window.App.get('apiBaseUrl')+data.file.url;

        let $buttonShow = $('<a/>')
        .attr('download','download')
        .attr('href',url)
        .addClass('btn btn-success')
        .append(
            $('<i/>')
            .addClass("fas fa-file-excel me-1")
        )
        .append(window.translate('app.product.export.excel.download.label'))


        this.$resultContainer
        .html('')
        .append($buttonShow)
        .show();
    }

    onChangeCheckboxEnableFilter(event){
        if(this.$checkboxEnableFilter.is(':checked')){
            this.$filterContainer.show();
            this.$inputFrom.removeAttr('disabled');
            this.$inputTo.removeAttr('disabled');
        }else{  
            this.$filterContainer.hide();
            this.$inputFrom.attr('disabled','disabled');
            this.$inputTo.attr('disabled','disabled');
        }
    }
}

module.exports = ExcelModal;

